const ROKT_CDN_URL = process.env.ROKT_CDN_URL;
const ROKT_SERVICE = 'roktService';

export { ROKT_CDN_URL, ROKT_SERVICE };
